/* eslint-disable no-else-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
const state = {
    showHealthModal: false,
    showInvoiceModal: false,
    showShoppingModal: false,
    showAutoLoanModal: false,
    showWalletModal: false,
};

const getters = {
    homepageRoute: (store, getters, rootState) => {
        const isUserCanPost = !!rootState.user.can_post_offers;
        if (isUserCanPost) {
            return {
                name: 'offers-create',
            };
        } else {
            return {
                name: 'offers-list',
            };
        }
    },
    navItems: (store, getters, rootState) => {
        const isUserCanPost = !!rootState.user.can_post_offers;
        if (isUserCanPost) {
            return [
                {
                    text: 'Send Money Internationally',
                    route: { name: 'offers-create' },
                    icon: 'call-made',
                    exact: true,
                },
                {
                    text: 'Request Money Internationally',
                    route: { name: 'offers-list' },
                    icon: 'call-received',
                    exact: true,
                },
            ];
        } else {
            return [
                {
                    text: 'International Money Transfer',
                    route: { name: 'offers-list' },
                    icon: 'arrow-decision-outline',
                    exact: true,
                },
            ];
        }
    },
    menuNavItems: (store, getters, rootState) => {
        const isUserCanPost = !!rootState.user.can_post_offers;
        return [
            {
                text: 'Transfer Status',
                route: { name: 'transfers' },
                icon: 'transfer',
                exact: true,
                key: !isUserCanPost ? 'transfers' : null,
            },
            {
                text: !isUserCanPost ? 'Request Summary' : 'Request Status',
                route: { name: 'requests' },
                icon: 'view-list',
                exact: true,
                key: isUserCanPost ? 'requests' : null,
            },
            {
                text: 'Rate Alert',
                route: { name: 'rate-alert-create' },
                icon: 'car-brake-alert',
                exact: true,
            },
            {
                text: 'Invite Friend/Family',
                route: { name: 'user-invite' },
                exact: true,
                icon: 'share-variant',
                class: 'primary white--text font-weight-bold',
            },
            {
                text: 'Payment Received',
                route: { name: 'received-payments' },
                icon: 'call-received',
                exact: true,
            },
            {
                text: 'Profile Settings',
                route: { name: 'user-settings' },
                icon: 'account-circle',
                exact: true,
            },
            {
                text: 'Recipients List',
                route: { name: 'recipient-list' },
                icon: 'format-list-bulleted',
                exact: true,
            },
            {
                text: 'Help Center',
                route: { name: 'help-center' },
                icon: 'help-circle',
                exact: true,
            },
        ];
    },
    showHealthModal: ({ showHealthModal }) => showHealthModal,
    showInvoiceModal: ({ showInvoiceModal }) => showInvoiceModal,
    showShoppingModal: ({ showShoppingModal }) => showShoppingModal,
    showAutoLoanModal: ({ showAutoLoanModal }) => showAutoLoanModal,
    showWalletModal: ({ showWalletModal }) => showWalletModal,
};

const mutations = {
    SET_MODAL_STATE(state, { type, value }) {
        state[type] = value;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
};
